import React, { useEffect } from "react";
import { motion } from "framer-motion";

// Brand intro that plays once per session, then slides up to reveal the site.
// Tap/click anywhere to skip.
const Intro = ({ onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 2100);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      className="fixed inset-0 z-[100] bg-ink flex items-center justify-center cursor-pointer"
      onClick={onDone}
      initial={{ opacity: 1 }}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
      aria-hidden="true"
    >
      <div className="text-center px-6">
        <motion.span
          className="eyebrow text-brass-light block mb-5"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
        >
          Ourika Valley · Morocco
        </motion.span>
        <motion.h1
          className="font-serif font-light text-5xl md:text-7xl text-cream tracking-wide"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.35 }}
        >
          Laurier <span className="text-brass-light">Rose</span>
        </motion.h1>
        <motion.div
          className="h-px bg-brass-light mx-auto mt-6"
          initial={{ width: 0 }}
          animate={{ width: 140 }}
          transition={{ duration: 0.9, delay: 0.7 }}
        />
      </div>
    </motion.div>
  );
};

export default Intro;
